import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_ALL_CHAT_USER,
  FETCH_ALL_CHAT_USER_CONVERSATION,
} from "constants/ActionTypes";
import {
  fetchChatUserConversationSuccess,
  fetchChatUserSuccess,
  showChatMessage,
} from "actions/Chat";

const getChatUsers = async () => {
    try {
        // Example: Fetching chat users from a REST API instead of Firebase
        const response = await fetch('/api/chat/users');  // Replace with your API endpoint
        const data = await response.json();

        const chatUsers = [];

        data.forEach((rawData) => {
            chatUsers.push(rawData);
        });

        return chatUsers;
    } catch (error) {
        console.error('Error fetching chat users:', error);
        return error;
    }
};

const getUsersConversation = async () => {
    try {
        // Example: Fetching user conversations from a REST API instead of Firebase
        const response = await fetch('/api/chat/conversation');  // Replace with your API endpoint
        const data = await response.json();

        const conversations = [];

        data.forEach((rawData) => {
            const conversation = rawData;

            // Convert object to array if conversationData exists
            const conversationDatas = [];
            if (conversation.conversationData) {
                conversation.conversationData.forEach((conversationData) =>
                    conversationDatas.push(conversationData)
                );
            }

            conversation.conversationData = conversationDatas;
            conversations.push(conversation);
        });

        return conversations;
    } catch (error) {
        console.error('Error fetching conversations:', error);
        return error;
    }
};

function* fetchChatUserRequest() {
  try {
    const fetchedTodo = yield call(getChatUsers);
    yield put(fetchChatUserSuccess(fetchedTodo));
  } catch (error) {
    yield put(showChatMessage(error));
  }
}

function* fetchChatUserConversationRequest() {
  try {
    const fetchedTodoConversation = yield call(getUsersConversation);
    yield put(fetchChatUserConversationSuccess(fetchedTodoConversation));
  } catch (error) {
    yield put(showChatMessage(error));
  }
}

export function* fetchChatUser() {
  yield takeEvery(FETCH_ALL_CHAT_USER, fetchChatUserRequest);
}

export function* fetchChatUserConversation() {
  yield takeEvery(
    FETCH_ALL_CHAT_USER_CONVERSATION,
    fetchChatUserConversationRequest
  );
}

export default function* rootSaga() {
  yield all([fork(fetchChatUserConversation), fork(fetchChatUser)]);
}
